import { CodeModuleEditor } from '@/components/document-view';
import type { CodeModuleLanguage } from '@/components/document-view';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

export interface ToolHandlerTabProps {
    value: string;
    onChange: (next: string) => void;
    language: CodeModuleLanguage;
    onLanguageChange: (lang: CodeModuleLanguage) => void;
    isLoading: boolean;
    readOnly: boolean;
}

export function ToolHandlerTab({
    value,
    onChange,
    language,
    onLanguageChange,
    isLoading,
    readOnly,
}: ToolHandlerTabProps) {
    if (isLoading) {
        return (
            <div className="flex min-h-[320px] items-center justify-center rounded-lg border border-dashed border-slate-200 bg-slate-50 text-sm text-slate-500">
                Loading handler…
            </div>
        );
    }

    return (
        <div className="space-y-3 px-24">
            <div className="flex items-center justify-end">
                <Select
                    value={language}
                    onValueChange={(v) => onLanguageChange(v as CodeModuleLanguage)}
                    disabled={readOnly}
                >
                    <SelectTrigger className="h-8 w-[160px] text-xs">
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="javascript">JavaScript</SelectItem>
                        <SelectItem value="typescript">TypeScript</SelectItem>
                        <SelectItem value="python">Python</SelectItem>
                        <SelectItem value="json">JSON</SelectItem>
                        <SelectItem value="plain">Plain Text</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <CodeModuleEditor
                value={value}
                language={language}
                readOnly={readOnly}
                onChange={readOnly ? undefined : onChange}
                className="min-h-[480px] rounded-lg border border-slate-200"
            />
        </div>
    );
}
